import React, { Fragment } from "react";
import Select from "react-select";
import ReactSelect from "react-select";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import MenuList from "../../../components/ContentUpload/MenuList";
import SingleValue from "../../../components/ContentUpload/SingleValue";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";
import PendingIconImage from "../../../assets/media/icons/pending.png";
import { user_actions } from "../../../Utils/Constants";
import { ContentTypes } from "../../../Constants/selections";
import Firebase from "../../../firebasehelper";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../../Constants/types";
import { UPLOADING_VIDEO } from "../../../Constants/string";
import { pages } from "../../../Constants/selections";
import "./index.css";
class EditTokenEarningModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      token: 0,
      page: "",
      selectedPage: "",
      user_action: "",
      media_type: IMAGE_UPLOAD,
      media_url: "",
      uploading: false,
    };
  }

  componentDidMount() {
    const { title, token, selectedPage, user_action } = this.props;
    this.setState({
      title,
      token,
      page: { value: selectedPage, label: selectedPage },
      user_action: user_actions.find((item) => item.value === user_action),
    });
  }

  componentDidUpdate(prevProps) {
    const { title, token, selectedPage, user_action, media_type, media_url } =
      this.props;
    if (
      title !== prevProps.title ||
      token !== prevProps.token ||
      selectedPage !== prevProps.selectedPage ||
      user_action !== prevProps.user_action
    ) {
      this.setState({
        title,
        token,
        page: { value: selectedPage, label: selectedPage },
        user_action: user_actions.find((item) => item.value === user_action),
        media_type,
        media_url,
      });
    }
  }

  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };
  handleSelectContentType = ({ value }) => {
    this.setState({ media_type: value });
  };
  onSave = () => {
    const { onSave, icon, id } = this.props;
    const { title, token, page, user_action, media_type, media_url } =
      this.state;
    onSave(id, {
      icon,
      title,
      token,
      media_type: media_type || null,
      media_url: media_url || null,
      page: page.label || null,
      action: user_action.value,
    });
    this.setState({
      title: "",
      token: 0,
      page: "",
      user_action: "",
      media_type: "",
      media_url: "",
    });
  };
  uploadContent = (contentType) => async (mediaContent) => {
    const uploadFolder = "taskers/";
    const title = new Date().getTime().toString();
    if (contentType === GIF_UPLOAD) {
      this.setState({ uploading: true });
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      this.setState({ uploading: false, media_url: gif_url });
    } else if (contentType === IMAGE_UPLOAD) {
      this.setState({ uploading: true });
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      this.setState({ uploading: false, media_url: img_url });
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      this.setState({ uploading: true });
      uploadTask.on(
        "state_changed",
        this.handleUploadProgress,
        this.handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            this.setState({
              uploading: false,
              loadingScript: "",
              media_url: downloadURL,
            });
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      this.setState({ media_url: mediaContent });
    }
  };
  handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    this.setState({ loadingScript: loading_script });
  };
  handleUploadError = (error) => {
    this.setState({ uploading: false });
  };
  render() {
    const {
      title,
      token,
      page,
      user_action,
      media_type,
      media_url,
      loadingScript,
      uploading,
    } = this.state;
    return (
      <div
        className="modal fade token-earning-dialog"
        id="edit_token_earning_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content add-token-earning-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit token earning</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 token-earning-dialog-body">
              <div className="icon-container">
                <button
                  type="button"
                  className="btn btn-warning choose-icon-btn"
                  data-toggle="modal"
                  data-target="#choose_icon"
                >
                  Choose Icon
                </button>
                <img
                  src={this.props.icon ? this.props.icon : PendingIconImage}
                  width="40"
                  alt="icon"
                />
              </div>
              <p className="token-earning-property-title">
                Upload an image,gif or video
              </p>
              <div className="form-group row">
                <div className="col-12">
                  <ReactSelect
                    value={{ label: media_type, value: media_type }}
                    onChange={this.handleSelectContentType}
                    options={ContentTypes}
                    placeholder="What content would you like to add?"
                    isSearchable={false}
                    components={{ MenuList, SingleValue }}
                  ></ReactSelect>
                </div>
              </div>
              {media_type && (
                <div className="col-div mb-2">
                  {media_type === YOUTUBE_URL && (
                    <YoutubeInput
                      onChangeContent={this.uploadContent(YOUTUBE_URL)}
                      currentUrl={media_url}
                    />
                  )}
                  {media_type === IMAGE_UPLOAD && (
                    <ImageUpload
                      onChangeContent={this.uploadContent(IMAGE_UPLOAD)}
                      contentUrl={media_url}
                    />
                  )}
                  {media_type === GIF_UPLOAD && (
                    <ImageUpload
                      isGif={true}
                      onChangeContent={this.uploadContent(GIF_UPLOAD)}
                      contentUrl={media_url}
                    />
                  )}
                  {media_type === VIDEO_UPLOAD && (
                    <VideoUpload
                      onChangeContent={this.uploadContent(VIDEO_UPLOAD)}
                      defaultVideo={media_url}
                    />
                  )}
                </div>
              )}
              <Fade
                in={uploading}
                style={{
                  transitionDelay: uploading ? "800ms" : "0ms",
                }}
                unmountOnExit
              >
                <Fragment>
                  <p>{loadingScript}</p>
                  <CircularProgress />
                </Fragment>
              </Fade>
              <p className="token-earning-property-title">
                Token Earning Title
              </p>
              <input
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("title")}
                value={title}
              />
              <p className="token-earning-property-title">Number of tokens</p>
              <input
                type="text"
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("token")}
                value={token}
              />
              <div className="page-action-container">
                <div style={{ width: "45%" }}>
                  <p className="token-earning-property-title">Pages</p>
                  <div className="page-select-container">
                    <Select
                      options={Object.values(pages).map((page) => ({
                        value: page.id,
                        label: page.name,
                      }))}
                      onChange={(value) => this.setState({ page: value })}
                      value={page}
                    ></Select>
                  </div>
                </div>
                <div style={{ width: "45%" }}>
                  <p className="token-earning-property-title">User Actions</p>
                  <div
                    className="page-select-container"
                    style={{ width: "100%" }}
                  >
                    <Select
                      options={user_actions}
                      onChange={(value) =>
                        this.setState({ user_action: value })
                      }
                      value={user_action}
                    ></Select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="btn-action-container">
                <button
                  type="button"
                  className="btn btn-sm btn-light add-token-warning-btn"
                  data-dismiss="modal"
                  onClick={this.onSave}
                  disabled={!this.props.icon || !token || !title || !page}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditTokenEarningModal;



// WEBPACK FOOTER //
// ./src/screens/TokenEarning/EditTokenEarningModal/index.js